<div class="modal-overlay" aria-modal="true" (click)="onClose()">
  <div class="modal-content qr-dialog-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>{{ 'PATIENT.ADD_FILE_FROM_PHONE' | translate }}</h2>
      <button class="close-btn" (click)="onClose()" [title]="'close' | translate">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="modal-body text-center">
      @if (!isExpired()) {
        <p class="instruction-text">
          {{ 'ATTACHMENT.QR_INSTRUCTION' | translate }}
        </p>
        <div class="qr-container">
          <canvas #qrCanvas></canvas>
        </div>
        <p class="expiry-text">{{ 'ATTACHMENT.TIME_REMAINING' | translate }}: {{ timeRemaining() }}</p>
      } @else {
        <div class="expired-container">
          <span class="material-icons error-icon">warning</span>
          <p class="expired-text">{{ 'ATTACHMENT.QR_EXPIRED' | translate }}</p>
          <button class="btn btn-primary" (click)="onGenerateNewQr()">
            {{ 'ATTACHMENT.GENERATE_NEW_QR' | translate }}
          </button>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onClose()">{{ 'close' | translate }}</button>
    </div>
  </div>
</div>
